import { render, staticRenderFns } from "./USnackbar.vue?vue&type=template&id=1014a756"
import script from "./USnackbar.vue?vue&type=script&lang=js"
export * from "./USnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports